// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 159) return "static/chunks/159-1b2fa452a627303f.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 233 ? "fcd35612" : chunkId) + "." + {"82":"d96813015e436ace","233":"3038a4ad0bac2cba","525":"de4070384c59282c","638":"58aef2b734bf9ccd","758":"2f8a17dfdb5e5311"}[chunkId] + ".js";
};